
import Button from '../../Atoms/Buttons/Button.vue'
export default {
  components: {
    Button
  },
  props: {
    labels: {
      type: Object,
      required: true,
      default: () => {}
    },
    opened: {
      type: Boolean,
      required: true,
      default: false
    },
    newCurrency: {
      type: String,
      default: false
    }
  },
  components: {Button},
  data() {
    return {
      modalOpened: this.opened,
    }
  },
  watch: {
    opened(value) {
      this.modalOpened = value
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.newCurrency)
    },
    close() {
      this.modalOpened = false
      this.$emit('closeModal')
    }
  }
}
